var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-neutral-100 py-6"},[_c('div',{staticClass:"container-app text-center"},[_c('p',{staticClass:"text-neutral-500 text-sm"},[_vm._v(" © 2026 by RECC. ")])])])
}]

export { render, staticRenderFns }